export default {"src":"/_next/static/media/bar-model.b3b4a62d.svg","height":125,"width":134,"blurWidth":0,"blurHeight":0};